import { Box, Typography } from '@material-ui/core'
import Campaign from '../../Campaign'
import Loading from '../../Loading'
import NoData from '../../NoData'
import { useClasses } from './useClasses'
import { useGroup } from './useGroup'

export const Group = () => {
  const { campaignCollection, isLoaded } = useGroup()
  const classes = useClasses()
  const empty = !campaignCollection.length

  return (
    <Box className={classes.root}>
      {isLoaded && empty && <NoData />}
      {isLoaded &&
        !empty &&
        campaignCollection.map((campaign, index) => {
          const keyGroupCampaign = `${index}_campaign`
          return <Campaign {...campaign} key={keyGroupCampaign} />
        })}
      {!isLoaded && <Loading />}
    </Box>
  )
}
